<div class="report-notes-navigation">
    <div class="report-notes-navigation__title">
        <span>Início</span>
    </div>
    @defer (when report()) {
        @for (report of reportIndex; track $index) {
            <div
                class="report-notes-navigation__report-info-container hover-pointer gap-4"
                [ngClass]="{
                    'report-notes-navigation__report-info-container--active':
                        activesAccordion === report.accordionId
                }"
                fxLayout="column"
                matTooltipClass="font-weight-semi-bold"
                [matTooltip]="report.tooltip"
            >
                <div
                    fxLayout="row"
                    fxLayoutAlign="space-between start"
                    class="full-width"
                    (click)="onSelectTopic(null, report.accordionId)"
                >
                    <div class="report-notes-navigation__report-info">
                        <span class="color-text-primary text-14-regular">{{
                            report.label
                        }}</span>

                        <!-- <span class="report-page">Página {{ report.page }}</span> -->
                    </div>
                </div>
                <div
                    fxLayout="row"
                    fxLayoutAlign="space-between center"
                    class="full-width"
                    style="position: relative"
                >
                    <span class="color-text-primary text-12-regular">{{
                        report.description
                    }}</span>

                    <mat-slide-toggle
                        [checked]="preferenceService.get(report.preference)"
                        (change)="onChangeSwitchPreference(report.preference)"
                        [hideIcon]="true"
                        style="position: absolute; right: 0; top: -7px"
                    ></mat-slide-toggle>
                </div>
            </div>
        }
    } @placeholder {
        <div
            fxLayout="column"
            fxLayoutAlign="start stretch"
            class="gap-12"
            style="padding: 0 var(--spacing-16)"
        >
            <dsn-skeleton-loader
                [type]="'rectangle'"
                [width]="'100%'"
                [height]="'44px'"
            ></dsn-skeleton-loader>
            <dsn-skeleton-loader
                [type]="'rectangle'"
                [width]="'100%'"
                [height]="'44px'"
            ></dsn-skeleton-loader>
            <dsn-skeleton-loader
                [type]="'rectangle'"
                [width]="'100%'"
                [height]="'44px'"
            ></dsn-skeleton-loader>
        </div>
    }
    @if (report()?.visualizations?.visualzations?.length > 0) {
        <div
            class="report-notes-navigation__title"
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span>Indicadores</span>
            <dsn-button-rounded
                [type]="'secondary'"
                [radius]="'full'"
                [icon]="'fa-solid fa-pencil'"
                [size]="'medium'"
                (onClick)="onOpenEditIndicatorsDialog()"
                class="button-indicators-edit"
            ></dsn-button-rounded>
        </div>
    }
    @if (report()?.props?.type === "projection") {
        <div
            id="navigation-notes-projection"
            class="report-notes-navigation__report-topics hover-pointer gap-16"
            fxLayout="column"
            fxLayoutAlign="start none"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="full-width"
                (click)="onSelectTopic('projection', 'SectionIndicators')"
            >
                <div class="report-notes-navigation__topics-info">
                    <p class="color-text-primary text-14-regular">Projeção</p>

                    <!-- <p class="report-topics-page">Página {{ $index + 1 }}</p> -->
                </div>

                <!-- <dsn-button
                    [prelabel]="''"
                    style="font-size: 20px"
                    [type]="'secondary'"
                    [size]="'medium'"
                    [disabled]="false"
                    [active]="false"
                    [fontWeight]="'bold'"
                    [onlyIcon]="'fa-solid fa-comments'"
                    (onClick)="onOpenCommentsPostDialog(visualization)"
                ></dsn-button> -->
            </div>
        </div>
    }
    @for (visualization of report()?.getVisualizationsVisible(); track $index) {
        <div
            id="navigation-notes-{{ visualization.props._id }}"
            class="report-notes-navigation__report-topics hover-pointer gap-16"
            fxLayout="column"
            fxLayoutAlign="start none"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="full-width"
                (click)="
                    onSelectTopic(visualization.props._id, 'SectionIndicators')
                "
            >
                <div class="report-notes-navigation__topics-info">
                    <p class="color-text-primary text-14-semi-bold">
                        {{ visualization.props.name }}
                    </p>
                    <p class="color-text-primary text-14-regular">
                        {{
                            report()?.isMultiSource ? `Fonte: ${visualization.sourceLabel}` : ''
                        }}
                    </p>

                    <!-- <p class="report-topics-page">Página {{ $index + 1 }}</p> -->
                </div>

                <dsn-button-menu-chips
                    mainIcon="fa-solid fa-comments"
                    size="medium"
                    (onClick)="
                        onOpenCommentsPostDialog(visualization);
                        onSelectTopic(
                            visualization.props._id,
                            'SectionIndicators'
                        )
                    "
                ></dsn-button-menu-chips>
                <!-- <dsn-button
                    [prelabel]="''"
                    style="font-size: 20px"
                    [type]="'secondary'"
                    [size]="'medium'"
                    [disabled]="false"
                    [active]="false"
                    [fontWeight]="'bold'"
                    [onlyIcon]="'fa-solid fa-comments'"
                    (onClick)="onOpenCommentsPostDialog(visualization)"
                ></dsn-button> -->
            </div>

            @if (!visualization.note) {
                <dsn-button
                    [prelabel]="''"
                    [label]="'Adicionar Nota'"
                    [type]="'secondary'"
                    [size]="'medium'"
                    [disabled]="false"
                    [iconLeft]="'fa-solid fa-plus'"
                    [iconRight]="''"
                    [active]="false"
                    [fontWeight]="'bold'"
                    justify="center"
                    width="full"
                    (onClick)="
                        onOpenAddNoteDialog(visualization);
                        onSelectTopic(
                            visualization.props._id,
                            'SectionIndicators'
                        )
                    "
                ></dsn-button>
            } @else {
                <dsn-button
                    [prelabel]="''"
                    [label]="'Editar Nota'"
                    [type]="'secondary'"
                    [size]="'medium'"
                    [disabled]="false"
                    [iconLeft]="'fa-solid fa-pencil'"
                    [iconRight]="''"
                    [active]="false"
                    justify="center"
                    [fontWeight]="'bold'"
                    width="full"
                    (onClick)="
                        onOpenAddNoteDialog(visualization);
                        onSelectTopic(
                            visualization.props._id,
                            'SectionIndicators'
                        )
                    "
                ></dsn-button>
            }

            <div class="report-notes-navigation__divider"></div>
        </div>
    }
</div>
